export const GetStatusColor = (statusColor, daysToExpire) => {
    switch (statusColor) {
        case "green":
            return "Dentro do prazo";
        case "yellow":
            return "Próximo do vencimento";
        case "red":
            if (daysToExpire <= 0) {
                return "Vencido";
            } else if (daysToExpire > 0) {
                return "Vencendo";
            }
            break;
        default:
            return "";
    }
};
